import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createSpark(): DrawFn {
  const rng = mulberry32(7)
  const embers = Array.from({ length: 110 }, () => ({
    a: rng() * TAU,
    speed: 28 + rng() * 110,
    size: 0.5 + rng() * 2.4,
    delay: rng() * 1.4,
    life: 1.8 + rng() * 2.4,
    drift: (rng() - 0.5) * 18,
    hot: rng(),
  }))

  return (ctx, t, w, h) => {
    const cx = w * 0.5
    const cy = h * 0.42
    ctx.clearRect(0, 0, w, h)
    ctx.globalCompositeOperation = 'lighter'

    const born = easeOutCubic(clamp(t / 1.15))
    const pulse = 0.82 + Math.sin(t * 3.1) * 0.18

    glow(ctx, cx, cy, 160 * pulse * born, 'rgba(255,70,20,0.22)')
    glow(ctx, cx, cy, 70 * pulse * born, 'rgba(255,150,50,0.45)')
    glow(ctx, cx, cy, 22 * pulse * born, 'rgba(255,236,200,0.95)')

    const ring = easeOutCubic(clamp((t - 0.15) / 1.4))
    if (ring > 0 && ring < 1) {
      ctx.strokeStyle = `rgba(255,110,40,${0.45 * (1 - ring)})`
      ctx.lineWidth = 2.2
      ctx.beginPath()
      ctx.arc(cx, cy, 16 + ring * Math.min(w, h) * 0.48, 0, TAU)
      ctx.stroke()
    }

    const ring2 = easeOutCubic(clamp((t - 0.55) / 1.6))
    if (ring2 > 0 && ring2 < 1) {
      ctx.strokeStyle = `rgba(255,190,90,${0.28 * (1 - ring2)})`
      ctx.lineWidth = 1.2
      ctx.beginPath()
      ctx.arc(cx, cy, 10 + ring2 * Math.min(w, h) * 0.36, 0, TAU)
      ctx.stroke()
    }

    for (const e of embers) {
      const age = t - e.delay
      if (age < 0) continue
      const u = age / e.life
      if (u > 1) continue
      const fade = u < 0.15 ? u / 0.15 : 1 - (u - 0.15) / 0.85
      const dist = age * e.speed * 0.55
      const x = cx + Math.cos(e.a) * dist * 0.35 + Math.sin(t * 1.4 + e.a) * e.drift
      const y = cy - dist * 0.85 + Math.cos(t + e.a) * 4
      const a = fade * born * 0.9
      ctx.fillStyle =
        e.hot > 0.7
          ? `rgba(255,230,180,${a})`
          : `rgba(255,${90 + e.hot * 80 | 0},40,${a})`
      ctx.beginPath()
      ctx.arc(x, y, e.size * (1 - u * 0.4), 0, TAU)
      ctx.fill()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
